// extracted by mini-css-extract-plugin
module.exports = {"container":"NewSchoolYearWarning_container__AVWcH"};